import { Guid } from "@/types"

export interface IProductModelDTO {
    id: Guid
    description?: string
}

export interface IProductModel {
    id: Guid
    description?: string
}

export default class ProductModel implements IProductModel {
    constructor(
        public id: Guid,
        public description?: string
    ) {}

    static fromDTO(dto: IProductModelDTO): ProductModel {
        return new ProductModel(
            dto.id,
            dto.description,
        )
    }
}
